import "../styles/style.scss";
import { api } from "./lib/api";

let notSubmittedCount = 0;
let submittedCount = 0;
let filterVal = "";
let tabType = "tabContents01";
let submittedList;
let notSubmittedList;
const rewardCounts = [1, 5, 10, 15, 20, 30, 45, 60, 75, 80];

window.onload = () => {
  api("get", `users/me/details`, undefined, (res) => {
    if (res && res.msg == "OK") {
      document.querySelector(".user__name").innerText =
        res.result.data.nickname;
    }
  });
  api("get", "games/burningBeaver/not-submitted", undefined, (res) => {
    if (res && res.msg == "OK") {
      if (res.result.data) {
        notSubmittedList = res.result.data;
        onLoadNotSubmittedList();
        api("get", "games/burningBeaver/submitted", undefined, (res) => {
          if (res && res.msg == "OK") {
            if (res.result.data) {
              submittedList = res.result.data;
              onLoadSubmittedList();
              api("get", "stores/burningstars", undefined, (res) => {
                if (res && res.msg == "OK") {
                  if (res.result.data) {
                    setBurningStars(res.result.data);
                    tabs();
                    guideToggle();
                    onClickSearch();
                    document.body.style.display = "block";
                  }
                }
              });
            }
          }
        });
      }
    } else {
      alert(`[API ERROR] : ${res.result.response.data.message}`);
    }
  });

  const tabs = () => {
    const tab = document.querySelectorAll(".tab__link");

    tab.forEach((item) => {
      item.addEventListener("click", (e) => {
        e.preventDefault();

        let tabsContainer = item.closest(".tabs");
        let targetHref = item.getAttribute("href");
        let targetContents = document.querySelector(targetHref);
        let tabsLink = tabsContainer.querySelectorAll(".tab__link");
        let tabContentsContainer = targetContents.parentNode;
        let tabContents =
          tabContentsContainer.querySelectorAll(".tab__contents");

        tabsLink.forEach((e) => {
          e.classList.remove("is-active");
        });

        tabContents.forEach((e) => {
          e.classList.remove("is-active");
          e.style.display = "none";
        });

        if (!item.classList.contains("is-active")) {
          tabType = item.href.split("#")[1];
          document.querySelector(".searchForm__input").value = "";
          filterVal = "";
          if (tabType == "tabContents01") {
            onLoadNotSubmittedList();
          } else if (tabType == "tabContents02") {
            onLoadSubmittedList();
          }
          item.classList.add("is-active");
          targetContents.style.display = "block";
        }
      });
    });
  };

  const guideToggle = () => {
    const guideBtn = document.querySelector(".guide__btn");

    guideBtn.addEventListener("click", (e) => {
      e.preventDefault();

      if (!guideBtn.classList.contains("is-active")) {
        guideBtn.classList.add("is-active");
      } else {
        guideBtn.classList.remove("is-active");
      }
    });
  };

  document.querySelector("#btnSerach").onclick = () => {
    onClickSearch();
  };
};

// 미참여 리스트 셋팅
function onLoadNotSubmittedList() {
  let listCount = 0;
  const container = document.querySelectorAll(".gameList__list")[0];
  const data = notSubmittedList;
  notSubmittedCount = data.count;
  container.innerHTML = "";
  data.contents.forEach((content) => {
    if (content.title.indexOf(filterVal) > -1) {
      listCount++;
      container.innerHTML += `<li class="gameList__listItem">
                    <div class="gameList__listImg">
                      <img src="${content.backgroundUrl}" alt="" />
                    </div>
                    <div class="gameList__listCon">
                      <div class="info">
                        <h2>${content.title}</h2>
                        <p>${content.company}</p>
                        <div class="tag is-fill-orange is-sm">
                          <i class="icon is-user"></i>${content.totCompletions}
                        </div>
                      </div>
                      <div class="btnWrap">
                        <a href="${
                          content.playUrl
                        }" class="btn is-round is-outline-gray"
                          >${isMobile() ? "게임하기" : "게임 플레이하기"}</a
                        >
                        <a href="./survey_1.html?gameId=${
                          content.id
                        }" class="btn is-round is-fill-orange"
                          >${isMobile() ? "설문하기" : "설문조사 참여"}</a
                        >
                      </div>
                    </div>
                  </li>`;
    }
  });
}

// 참여완료 리스트 셋팅
function onLoadSubmittedList() {
  let listCount = 0;
  const container = document.querySelectorAll(".gameList__list")[1];
  const data = submittedList;
  submittedCount = data.count;
  container.innerHTML = "";
  data.contents.forEach((content) => {
    if (content.title == null) {
      content.title = "(타이틀 없음)";
    }
    if (content.title.indexOf(filterVal) > -1) {
      listCount++;
      container.innerHTML += `<li class="gameList__listItem">
                    <div class="gameList__listImg">
                      <img src="${content.backgroundUrl}" alt="" />
                    </div>
                    <div class="gameList__listCon">
                      <div class="info">
                        <h2>${content.title}</h2>
                        <p>${content.company}</p>
                        <div class="tag is-fill-orange is-sm">
                          <i class="icon is-user"></i>${content.totCompletions}
                        </div>
                      </div>
                      <div class="btnWrap">
                        <a href="${
                          content.playUrl
                        }" class="btn is-round is-outline-gray"
                          >${isMobile() ? "게임하기" : "게임 플레이하기"}</a
                        >
                        <a class="btn is-round is-fill-gray"
                          >${isMobile() ? "참여완료" : "설문조사 참여"}</a
                        >
                      </div>
                    </div>
                  </li>`;
    }
  });
  document.querySelector(".gameList__count").innerText = `총 ${
    notSubmittedCount + submittedCount
  }개`;
}

// 버닝스타 현황 셋팅
function setBurningStars(data) {
  document.querySelector(".gameState__progressVal").innerText = `${
    data.currentBurningstarProgress
  } / ${notSubmittedCount + submittedCount}`;
  document.querySelector("progress").value = data.currentBurningstarProgress;
  document.querySelector("progress").max = notSubmittedCount + submittedCount;
  setPhaseOverviews(data);
}

// 버닝스타 현황 셋팅
function setPhaseOverviews(data) {
  const currentPhase = data.currentPhase;
  const nextBurningstarProgress = data.nextBurningstarProgress;
  data.phaseOverviews.forEach((overview, index) => {
    console.log(overview);
    document.querySelector(".rewardList").innerHTML += `
      <div class="rewardList__item ${
        overview.status == "APPROVED" ? "is-active" : ""
      } ${
      overview.status == "APPROVED" && data.currentPhase == index + 1
        ? "is-current"
        : ""
    }" >
          <span>${overview.phase}레벨</span>
            <div class="rewardList__img">
              <img src="${overview.imageUrl}" alt="" />
            </div>
          <div class="rewardList__btn"> 
        <button type="button" class="btn">${
          overview.status == "APPROVED"
            ? `${rewardCounts[index]}개`
            : `${
                currentPhase == index
                  ? nextBurningstarProgress
                  : rewardCounts[index]
              }개 ${index + 1 == data.phaseOverviews.length ? "이상" : ""}`
        }</button>
      </div>
    </div>`;
  });
}

// 검색 기능
function onClickSearch() {
  filterVal = document.querySelector(".searchForm__input").value;
  if (tabType == "tabContents01") {
    onLoadNotSubmittedList();
  } else if (tabType == "tabContents02") {
    onLoadSubmittedList();
  }
}

document
  .querySelector(".searchForm__input")
  .addEventListener("keydown", (e) => {
    if (e.code == "Enter") {
      onClickSearch();
    }
  });

const isMobile = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );
};
